module.exports = __webpack_public_path__ + "media/images/reviewers-docs-7b9aca1dda614f1b29ffb4aaa2e49581.png";